export default {
  zh: {
    newleads: '新增潜在客户',
    newaccounts: '新增客户',
    newObjects: '最近浏览',
    newopportunities: '新增机会',
    openActivity: '待办事项',
    subject: '主题',
    name: '姓名',
    dueDate: '截止日期',
    status: '状态',
    recently: '最近',
    today: '今天',
    viewMore: '浏览更多',
    edit: '编辑',
    updated: '更新',
    updateAllReports: '更新所有报告',
    updateThisReport: '更新此报告',
    sourceReportMessage: {
      upto12rows: '最多显示 12 条结果，点击',
      sourceReportLink: '源报告',
      checkMoreData: '查看更多数据。'
    },
    changeDashboard: '切换总览',
    updating: '正在更新',
    lastUpdate: '最后更新于',
    sum: '{label}总和',
    avg: '{label}平均数',
    count: '总条数',
    errors: {
      fieldsError: '总栏字段参数已更改，请修改总览报告',
      slotError: '槽内字段参数已更改，请修改总览报告',
    }
  },
  en: {
    newleads: 'New Leads',
    newaccounts: 'New Accounts',
    newObjects: 'Last View',
    newopportunities: 'New Opportunities',
    openActivity: 'Open Tasks',
    subject: 'Subject',
    name: 'Name',
    dueDate: 'Due Date',
    status: 'Status',
    recently: 'Recently',
    today: 'Today',
    viewMore: 'View More',
    edit: 'Edit',
    updated: 'Update',
    updateAllReports: 'Update all reports',
    updateThisReport: 'Update this report',
    sourceReportMessage: {
      upto12rows: 'Displaying up to 12 results, view more data from ',
      sourceReportLink: 'Source Report.',
      checkMoreData: ' '
    },
    changeDashboard: 'Change Dashboard',
    updating: 'Updating',
    lastUpdate: 'Last Updated',
    sum: 'Sum of {label}',
    avg: 'Average of {label}',
    count: 'Count',
    errors: {
      fieldsError: 'Dashboard field value changed, Please modify your Dashboard Reports',
      slotError: 'Slot field value changed, Please modify your Dashboard Reports',
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/Dashboard/i18n.js